// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Q0ABr","input":"styles_input__-gAig"};